<template>
  <li class="nav-cart" @mouseenter="showCar" @mouseleave="visibleCar">
    <router-link id="car-XY" to="/cart">购物车</router-link>
    <!--根据class改变颜色-->
    <span class="cart-empty-num" :class="{ 'cart-num': totalCount > 0 }">
      <i>{{ totalCount }}</i>
    </span>
    <div class="nav-cart-wrapper" v-if="carShow">
      <div class="nav-cart-list">
        <div class="empty" v-if="totalCount <= 0">
          <h3>购物车为空</h3>
          <p>您还没有选购任何商品，现在前往商城选购吧!</p>
        </div>
        <div class="full" v-else>
          <div class="nav-cart-items">
            <ul>
              <li
                class="clear"
                v-for="(item, index) in getCarPanelData"
                :key="index"
              >
                <div class="cart-item js-cart-item cart-item-sell">
                  <div class="cart-item-inner">
                    <div class="item-thumb">
                      <img :src="item.img" />
                    </div>
                    <div class="item-desc">
                      <div class="cart-cell">
                        <h4>
                          <a href="#/item/100027401">{{ item.title }}</a>
                        </h4>
                        <p class="attrs">
                          <span></span>
                        </p>
                        <h6>
                          <span class="price-icon">¥</span
                          ><span class="price-num">{{ item.price }}</span
                          ><span class="item-num">x {{ item.count }}</span>
                        </h6>
                      </div>
                    </div>
                    <div class="del-btn" @click="deleteCar(item)">删除</div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="nav-cart-total">
            <p>
              共 <strong class="ng-binding">{{ totalCount }}</strong> 件商品
            </p>
            <h5>
              合计：<span class="price-icon">¥</span
              ><span
                class="price-num ng-binding"
                ng-bind="cartMenu.totalPrice"
                >{{ totalPrice }}</span
              >
            </h5>
            <h6>
              <router-link class="nav-cart-btn" to="/cart"
                >去购物车</router-link
              >
            </h6>
          </div>
        </div>
      </div>
    </div>
    <transition
      @before-enter="beforeEnter"
      @enter="enter"
      @after-enter="afterEnter"
    >
      <div class="add-cart-mask" v-show="getBall.isShow">
        <img class="mask-item" :src="getBall.img" />
      </div>
    </transition>
  </li>
</template>

<script>
export default {
  computed: {
    getCarPanelData() {
      return this.$store.state.carPanelData;
    },
    totalCount() {
      return this.$store.getters.count;
    },
    totalPrice() {
      return this.$store.getters.totalPrice;
    },
    carShow() {
      return this.$store.state.carShow;
    },
    getBall() {
      return this.$store.state.ball;
    },
  },
  methods: {
    showCar() {
      this.$store.commit("showCar"); //触发mutations的showCar
    },
    visibleCar() {
      this.$store.commit("visibleCar"); //触发mutations的visibleCar
    },
    deleteCar(item) {
      this.$store.commit("deleteCar", item); //从购物车中删除商品
    },
    beforeEnter(e) {
      // var Rect = this.getBall.el.getBoundingClientRect();
      // var carXY = document.querySelector("#car-XY").getBoundingClientRect();
      // var x = carXY.x - Rect.x;
      // var y = Rect.y - carXY.y;
      // e.style.transform = "translate(-" + x + "px," + y + "px)";
    },
    enter(e) {
      e.offsetWidth; //强制刷新浏览器：必须写
      e.style.transform = "translate(0px,0px)";
      e.style.transition = "transform .8s";
    },
    afterEnter(e) {
      this.getBall.isShow = false;
      e.style.transition = "all 0s ease-out";
    },
  },
};
</script>

<style lang="css" scoped>
.add-cart-mask {
  width: 17px;
  height: 26px;
  position: relative;
  z-index: 9999;
}
.mask-item {
  position: absolute;
  top: -28px;
  left: 17px;
  widows: 17px;
  height: 26px;
}
</style>>


// WEBPACK FOOTER //
// src/components/car-panel.vue